export type RoleMenuMap = Record<string, string[]>;

export const RoleMenu: RoleMenuMap = {
  g_psbu_admin: ['*',]
};
